import { InfoWindow, Marker, useMarkerRef } from "@vis.gl/react-google-maps";
import React, { useCallback, useEffect, useState } from "react";
import {
  getDocumentByOpeAndRefAndDocCatAndFileNameDownscaled,
  getDownscaledFile,
} from "../../../api/documentUpload";
import NewPlaceholder from "../../../assets/placeholder_moving.gif";
import PlaceholderImage from "../../../assets/placeholder_static.png";
import { speedColor } from "../../../const";
import { getDirection } from "../../../helper";

const InfoWindowComponent = ({
  vehicleNo,
  speed,
  direction,
  manufacturer,
  model,
  lastUpdateTime,
  vehicleId,
}) => {
  const [vehicleImage, setVehicleImage] = useState(null);

  useEffect(() => {
    (async () => {
      const response =
        await getDocumentByOpeAndRefAndDocCatAndFileNameDownscaled(
          4,
          vehicleId,
          1,
          1,
        );
      if (response && response.length > 0) {
        const data = response[0];
        const fileData = await getDownscaledFile(data.docId);

        const file = new File([fileData], data.docName, {
          type: fileData.type,
        });

        setVehicleImage(file);
      }
    })();
  }, [vehicleId]);
  return (
    <div style={{ display: "flex", gap: "10px", padding: "10px" }}>
      <img
        style={{
          width: "150px",
          height: "120px",
        }}
        src={
          vehicleImage
            ? URL.createObjectURL(vehicleImage)
            : speed > 0
              ? NewPlaceholder
              : PlaceholderImage
        }
        alt={"veh"}
      />
      <div>
        <h3>
          {manufacturer ? manufacturer : "N/A"}
          <br /> {model ? model : "N/A"} ({vehicleNo})
        </h3>
        <p>Last Updated at - {lastUpdateTime}</p>
        {speed > 0 ? (
          <div
            style={{
              display: "flex",
              gap: "5px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <span>At </span>
              <span
                style={{
                  padding: "5px 15px",
                  borderRadius: "2px",
                  backgroundColor:
                    speed === 0
                      ? speedColor.STATIONARY
                      : speed > 60
                        ? speedColor.HIGH
                        : // : speed > 40
                          //   ? speedColor.MEDIUM
                          speedColor.LOW,
                  fontSize: "20px",
                  color: "white",
                }}
              >
                {speed}
              </span>
              <span>km/h heading </span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <span
                style={{
                  padding: "5px 15px",
                  borderRadius: "2px",
                  backgroundColor: "rgb(187, 187, 187)",
                  fontSize: "20px",
                  color: "white",
                }}
              >
                {getDirection(direction)}
              </span>
            </div>
          </div>
        ) : (
          <span
            style={{
              padding: "5px 15px",
              borderRadius: "2px",
              backgroundColor: "rgb(187, 187, 187)",
              fontSize: "20px",
              color: "white",
            }}
          >
            Vehicle Stationary
          </span>
        )}
      </div>
    </div>
  );
};

const LiveVehicle = ({ vehicle }) => {
  const [markerRef, marker] = useMarkerRef();

  const [infoWindowShown, setInfoWindowShown] = useState(false);

  const handleMarkerClick = useCallback(() => {
    setInfoWindowShown((isShown) => !isShown);
  }, []);

  const handleClose = useCallback(() => {
    setInfoWindowShown(false);
  }, []);

  const markerIcon = {
    path:
      vehicle?.speed === 0
        ? window.google.maps.SymbolPath.CIRCLE
        : window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
    scale: 5,
    rotation: vehicle.direction,
    fillColor: vehicle.speed === 0 ? "red" : "green",
    fillOpacity: 0.8,
    strokeWeight: 2,
  };

  return (
    <>
      <Marker
        ref={markerRef}
        icon={markerIcon}
        position={{
          lng: parseFloat(vehicle.lng),
          lat: parseFloat(vehicle.lat),
        }}
        onClick={handleMarkerClick}
      />
      {infoWindowShown && (
        <InfoWindow anchor={marker} onCloseClick={handleClose}>
          <InfoWindowComponent
            speed={vehicle.speed}
            direction={vehicle.direction}
            vehicleNo={vehicle.vehicleNo}
            vehicleId={vehicle.id}
            manufacturer={vehicle.manufacturer}
            model={vehicle.model}
            lastUpdateTime={vehicle.lastUpdateTime}
          />
        </InfoWindow>
      )}
    </>
  );
};

export default LiveVehicle;
